import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import authReducer from "./authSlice";
import userReducer from "./userSlice"; // Import userSlice
import mentorReducer from "./mentorSlice"; // Import userSlice
import chatReducer from "./chatSlice"; // Import userSlice
import profileFormReducer from "./profileFormSlice"; // Import profileFormSlice
import assessmentReducer from "./assessmentSlice"; // Import assessmentSlice

// Persist configurations for auth and user separately
const authPersistConfig = {
  key: "auth",
  storage,
};

const userPersistConfig = {
  key: "user",
  storage,
};

const mentorPersistConfig = {
  key: "mentor",
  storage,
};

const chatPersistConfig = {
  key: "chat",
  storage,
};

const profileFormPersistConfig = {
  key: "profileForm",
  storage,
  blacklist: ["step5"],
};

const assessmentPersistConfig = {
  key: "assessment",
  storage,
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedMentorReducer = persistReducer(
  mentorPersistConfig,
  mentorReducer
);
const persistedChatReducer = persistReducer(chatPersistConfig, chatReducer);
const persistedProfileFormReducer = persistReducer(profileFormPersistConfig, profileFormReducer);
const persistedAssessmentReducer = persistReducer(assessmentPersistConfig, assessmentReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer, // Persisted auth reducer
    user: persistedUserReducer, // Persisted user reducer
    mentor: persistedMentorReducer,
    chat: persistedChatReducer,
    profileForm: persistedProfileFormReducer,
    assessment: persistedAssessmentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredActionPaths: ['payload.data.profileImage'],
        ignoredPaths: ['_persist', 'profileForm.step5.profileImage'],
      },
    }),
});

export const persistor = persistStore(store);
